'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
exports.default = defaultShouldWarn;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/defaultShouldWarn.js
 ** module id = 479
 ** module chunks = 1
 **/